<mat-card [formGroup]="chatForm" class="tw-w-full tw-rounded-t-none">
    <mat-card-content>
        <div class="tw-row tw-flex tw-space-x-2 tw-items-center">
            <mat-form-field class="tw-w-full tw-mb-0" subscriptSizing="dynamic">
                <textarea
                    matInput
                    placeholder="Message"
                    formControlName="message"
                    (keydown.enter)="submit()"
                ></textarea>
            </mat-form-field>

            <button
                mat-fab
                color="primary"
                (click)="submit()"
                [disabled]="
                    !chatForm.get('message').value || (aiBuffering$ | async)
                "
            >
                <mat-icon>send</mat-icon>
            </button>

            <input
                #fileInput
                class="tw-hidden"
                id="input-file-id"
                multiple
                type="file"
                (change)="setSelectedFiles($event)"
            />

            <!-- TODO: implement attachments  <button mat-fab color="accent" disabled (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
            </button> -->
        </div>

        <h6 *ngIf="hasAttachments()">Attachments:</h6>

        <!--This element needs an ngStyle or ngClass Binding -->
        <mat-chip-list
            #chipList
            [ngClass]="['tw-row-auto tw-gap-3 tw-w-full tw-mb-2']"
            fxLayoutAlign="start center"
            matTooltip="These files will be uploaded as a attachment for the message above."
            matTooltipPosition="below"
        >
            <mat-chip
                *ngFor="let attachment of getAttachments(); let i = index"
                selected
                removable
                (removed)="deleteAttachment(attachment)"
                color="primary"
            >
                <mat-icon>insert_drive_file</mat-icon>
                {{ attachment.name }}
                <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>

        <mat-progress-bar
            *ngIf="getAttachments().length > 0"
            mode="determinate"
            value="getUploadPercentage(i) | async"
        ></mat-progress-bar>
    </mat-card-content>
</mat-card>
